<template>
  <div>
    <Row class="detail-header">
      <span>测购</span>
    </Row>
    <Row
      v-if="!isInfo" class="detail-form"
      style="padding-left:20px;"
    >
      <Form
        ref="formData" :model="formData"
        :rules="ruleValidate" :label-width="110"
      >
        <FormItem label="添加测购图片" prop="attachmentList">
          <file-upload
            :default-list="defaultList || []"
            :upload-config="uploadConfig"
            @getFileList="getAttachmentList"
          />
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input
            v-model.trim="formData.remark" type="textarea"
            :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写备注"
          />
        </FormItem>
        <FormItem label="是否需要邮寄" prop="isMail">
          <RadioGroup v-model="formData.isMail">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <Row v-if="formData.isMail">
          <FormItem
            label="邮寄公司" prop="company"
            :rules="[{required: true,message: '邮寄公司不能为空', trigger: 'blur'}]"
          >
            <Select
              v-model="formData.company" transfer
              placeholder="请选择快递公司"
            >
              <Option
                v-for="item in courierCompanyArr" :key="item.id"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="邮寄单号" prop="expressNo"
            :rules="[{required: true,message: '邮寄单号不能为空', trigger: 'change'},{ max:16,message:'不能超过16个字符',trigger:'blur'}]"
          >
            <Input v-model.trim="formData.expressNo" placeholder="请填写快递单号" />
          </FormItem>
          <FormItem label="邮寄人姓名" prop="senderName">
            <Input v-model.trim="formData.senderName" placeholder="请填写邮寄人姓名" />
          </FormItem>
          <FormItem label="邮寄人手机号" prop="senderMobile">
            <Input v-model.trim="formData.senderMobile" placeholder="请填写邮寄人手机号" />
          </FormItem>
          <FormItem label="邮寄人区域">
            <City
              ref="senderRedionRef" :city-list="cityList"
              @listenCity="getRegion"
            />
          </FormItem>
          <FormItem label="邮寄人详细地址" prop="senderAddress">
            <Input
              v-model="formData.senderAddress" type="textarea"
              :autosize="{minRows: 3,maxRows: 5}" placeholder="请输入详细地址"
            />
          </FormItem>
        </Row>
      </Form>
      <Row class="detail-btn-box">
        <Button
          type="primary" :disabled="isSumbit"
          @click="sumbitData"
        >保存</Button>
        <Button v-if="defaultData" @click="isInfo=true">取消</Button>
      </Row>
    </Row>
    <Row v-else class="detail-content">
      <Row>
        <Col span="5" class="left-label">测购图片：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="defaultList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
      <Row><Col span="5" class="left-label">备注：</Col><Col span="16" class="right-content">{{ defaultData.remark }}</Col></Row>
      <Row><Col span="5" class="left-label">是否需要邮寄：</Col><Col span="16" class="right-content">{{ defaultData.isMail?"是":"否" }}</Col></Row>
      <Row v-if="defaultData.isMail">
        <Row>
          <Col span="5" class="left-label">邮寄公司：</Col>
          <Col span="16" class="right-content">{{ defaultData.companyName }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">邮寄单号：</Col>
          <Col span="16" class="right-content">
            <a href="javascript:void(0);" @click="logisticsCtrl=true;">{{ defaultData.expressNo }}</a>
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">邮寄人姓名：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderName }}</Col>
        </Row>
        <Row />
        <Row>
          <Col span="5" class="left-label">邮寄人手机号：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderMobile }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">邮寄人区域：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderProvinceName+defaultData.senderCityName+defaultData.senderAreaName }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">邮寄人详细地址：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderAddress }}</Col>
        </Row>
      </Row>
      <Row v-if="clueDetail.state=='P' || clueDetail.state=='R'" style="text-align:center;margin:5px;">
        <Button @click="isInfo=false;">修改</Button>
      </Row>
    </Row>

    <!-- 物流信息 -->
    <Modal
      v-model="logisticsCtrl"
      :title="'快递单号'+defaultData.expressNo"
      width="550"
      :footer-hide="true"
    >
      <logistics-information
        v-if="logisticsCtrl" :express-no="defaultData.expressNo"
        :company="defaultData.company"
      />
    </Modal>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {},
  props: ['clueDetail'],
  data () {
    return {
      mainColor: styles,
      uploadConfig: {
        fileName: ''
      },
      courierCompanyArr: [],
      defaultList: [],
      isSumbit: false,
      isInfo: false,
      formData: {
        remark: '',
        attachmentList: [],
        isMail: '',
        company: '',
        expressNo: '',
        senderProvince: '', // 省
        senderCity: '', // 市
        senderArea: '', // 区
        senderAddress: '', // 详细地址
        senderName: '', // 邮寄人
        senderMobile: '' // 邮寄人电话
      },
      cityList: [],
      ruleValidate: {
        attachmentList: [{ required: true, type: 'array', message: '测购图片不能为空', trigger: 'blur' }],
        remark: [{ max: 500, message: '不能超过500个字符', trigger: 'blur' }],
        isMail: [{ required: true, type: 'number', message: '请选择是否邮寄', trigger: 'blur' }],
        senderName: [{ type: 'string', max: 32, message: '不能超过32个字符', trigger: 'blur' }],
        senderMobile: [
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确格式手机号', trigger: 'blur' }
        ],
        senderAddress: [{ type: 'string', max: 200, message: '不能超过200个字符', trigger: 'blur' }]
      },
      defaultData: '',
      logisticsCtrl: false
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getDictionary()
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    getAttachmentList (arr) {
      this.formData.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
      })
    },
    getDetail() {
      const url = `/business/clue/trial-order/info/${this.clueDetail.id}`
      this.$get(url).then(res => {
        if (res.data) {
          this.defaultData = res.data
          this.giveDefaultData()
          this.isInfo = true
        } else {
          this.isInfo = false
        }
      })
    },
    giveDefaultData() {
      this.formData.remark = this.defaultData.remark
      this.formData.company = this.defaultData.company
      this.formData.expressNo = this.defaultData.expressNo
      this.formData.senderName = this.defaultData.senderName || ''
      this.formData.senderMobile = this.defaultData.senderMobile || ''
      this.formData.senderAddress = this.defaultData.senderAddress || ''
      this.cityList = [this.defaultData.senderProvince, this.defaultData.senderCity, this.defaultData.senderArea]
      this.formData.isMail = this.defaultData.isMail ? 1 : 0
      this.formData.attachmentList = []
      this.defaultList = []
      this.defaultData.attachmentList.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
        this.defaultList.push(obj)
      })
    },
    sumbitData() {
      const url = '/business/clue/trial-order/info'
      const ajaxData = {
        clueId: this.clueDetail.id
      }
      Object.assign(ajaxData, this.formData)
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.isSumbit = true
          if (this.defaultData) {
            ajaxData.id = this.defaultData.id
            this.$patch(url, ajaxData).then(res => {
              this.isSumbit = false
              if (res.code == 0) {
                this.$Message.success('操作成功!')
                this.getDetail()
                this.$emit('changeEditCtrl', true)
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              this.isSumbit = false
              if (res.code == 0) {
                this.$Message.success('操作成功!')
                this.getDetail()
                this.$emit('changeEditCtrl', true)
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
    // 搜索条件省市区接口
    getRegion(data) {
      if (data.length != 0) {
        if (data.length == 1) {
          this.formData.senderProvince = data[0].value
          this.formData.senderCity = ''
          this.formData.senderArea = ''
        } else if (data.length == 2) {
          this.formData.senderProvince = data[0].value
          this.formData.senderCity = data[1].value
          this.formData.senderArea = ''
        } else if (data.length == 3) {
          this.formData.senderProvince = data[0].value
          this.formData.senderCity = data[1].value
          this.formData.senderArea = data[2].value
        }
      } else {
        this.formData.senderProvince = ''
        this.formData.senderCity = ''
        this.formData.senderArea = ''
      }
    },
    // 数据字典
    async getDictionary() {
      this.courierCompanyArr = await this.common.getDictionaryItems('courier_company')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/testPurchaseForm.vue